export function getWorkContextRoleNames(user) {
  const values = [user?.rol, user?.role, ...(Array.isArray(user?.roles) ? user.roles : [])];
  return Array.from(
    new Set(
      values
        .map((value) => {
          if (typeof value === "object" && value) return value.name || value.naam || value.key || "";
          return String(value || "");
        })
        .map((value) => String(value).trim())
        .filter(Boolean)
    )
  );
}

export function formatWorkContextRole(value) {
  const normalized = String(value || "").trim().toLowerCase();
  const labels = {
    platformadmin: "PlatformAdmin",
    tenantadmin: "TenantAdmin",
    projectleider: "Projectleider",
    werkvoorbereider: "Werkvoorbereider",
    monteur: "Monteur",
    customer_portal: "Klantportaal",
    klantportaal: "Klantportaal",
    root: "Root",
  };
  return labels[normalized] || String(value || "").trim();
}
